// extracted by mini-css-extract-plugin
module.exports = {"QuestionsManage":"styles_QuestionsManage__3D4PV"};